exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container-fluid[_v-d3c64f1e]{width:70%;margin-top:40px}.carousel-control[_v-d3c64f1e]{width:10%}.project-img[_v-d3c64f1e]{background-position:50%;background-repeat:no-repeat;background-size:cover;height:300px}@media (min-width:768px){.container-fluid[_v-d3c64f1e]{float:right}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-d3c64f1e&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Projects/Carousel.vue
// module id = 462
// module chunks = 0